import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=34c49f72&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=34c49f72&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c49f72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c49f72')) {
      api.createRecord('34c49f72', component.options)
    } else {
      api.reload('34c49f72', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=34c49f72&scoped=true", function () {
      api.rerender('34c49f72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InventionApply/Terms.vue"
export default component.exports